import { useId } from "react";

interface TooltipProps {
  tip: string;
  label?: string;
}

export function Tooltip({ tip, label }: TooltipProps) {
  const tipId = useId();
  return (
    <span className="tooltip-wrap">
      <button
        type="button"
        className="tooltip"
        aria-describedby={tipId}
        aria-label={label ? `${label} — more info` : "More info"}
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden>
          <circle cx="6" cy="6" r="5" stroke="currentColor" strokeWidth="1.2" />
          <path d="M6 5v3M6 3.5v.2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        </svg>
      </button>
      <span className="tooltip-text" role="tooltip" id={tipId}>
        {tip}
      </span>
    </span>
  );
}
